import { useState } from 'react'
import type { FormEvent } from 'react'
import { Button } from '@/components/Button'
import { Card, CardBody, CardHeader } from '@/components/Card'
import { TextField } from '@/components/Form'
import { PasswordRules } from '@/components/PasswordRules'
import { useChangePassword } from '@/hooks/useAccount'
import { passwordIsValid } from '@/lib/validation'

export function PasswordCard() {
  const changePassword = useChangePassword()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')

  const mismatch = confirm.length > 0 && confirm !== next
  const canSubmit = current.length > 0 && passwordIsValid(next) && !mismatch && confirm.length > 0

  function onSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    if (!canSubmit) return
    changePassword.mutate(
      { currentPassword: current, newPassword: next },
      {
        onSuccess: () => {
          setCurrent('')
          setNext('')
          setConfirm('')
        },
      },
    )
  }

  return (
    <Card>
      <CardHeader
        title="Password"
        description="Changing it here changes it on the media server too."
      />
      <CardBody>
        {/* One column on every width: password fields side by side invite
            typing the new password into the current-password box. */}
        <form onSubmit={onSubmit} className="max-w-md space-y-4">
          <TextField
            label="Current password"
            type="password"
            autoComplete="current-password"
            required
            value={current}
            onChange={(event) => setCurrent(event.target.value)}
          />
          <TextField
            label="New password"
            type="password"
            autoComplete="new-password"
            required
            value={next}
            onChange={(event) => setNext(event.target.value)}
          />
          <PasswordRules value={next} />
          <TextField
            label="Confirm new password"
            type="password"
            autoComplete="new-password"
            required
            value={confirm}
            error={mismatch ? 'These two do not match.' : null}
            onChange={(event) => setConfirm(event.target.value)}
          />
          <Button
            type="submit"
            variant="primary"
            className="w-full sm:w-auto"
            loading={changePassword.isPending}
            disabled={!canSubmit}
          >
            Change password
          </Button>
        </form>
      </CardBody>
    </Card>
  )
}
